const API_BASE = 'https://api.dev.auxo.dk';

/**
 * Transforms Auxo Asset CDN URLs with Cloudflare on-the-fly resizing and auto webp/avif format.
 */
export function getOptimizedImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string') return '';
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }
  const { width = 1200, quality = 82, format = 'auto', fit = 'cover', height } = options;
  const params = [`width=${width}`, `quality=${quality}`, `format=${format}`];
  if (height) {
    params.push(`height=${height}`);
    params.push(`fit=${fit}`);
  }
  const match = url.match(/^https?:\/\/assets\.auxodev\.dk\/(.+)$/);
  if (match && match[1]) {
    return `https://assets.auxodev.dk/cdn-cgi/image/${params.join(',')}/${match[1]}`;
  }
  return url;
}

/**
 * Fetch collection from CMS v2 API
 */
export async function fetchCollection(collectionName, params = {}) {
  try {
    const url = new URL(`${API_BASE}/public/v2/content/${collectionName}`);
    Object.entries(params).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== '') {
        url.searchParams.append(key, val);
      }
    });
    const res = await fetch(url.toString());
    if (!res.ok) {
      console.warn(`CMS fetch failed for ${collectionName}: ${res.status}`);
      return { items: [], total: 0 };
    }
    const data = await res.json();
    return data && data.items ? data : { items: Array.isArray(data) ? data : [], total: Array.isArray(data) ? data.length : 0 };
  } catch (err) {
    console.error(`Error fetching collection ${collectionName}:`, err);
    return { items: [], total: 0 };
  }
}

/**
 * Fetch a single page by page_slug
 */
export async function fetchPageBySlug(slug) {
  try {
    const data = await fetchCollection('pages', { page_slug: slug, limit: 1 });
    return data.items && data.items.length > 0 ? data.items[0] : null;
  } catch (err) {
    console.error(`Error fetching page ${slug}:`, err);
    return null;
  }
}

/**
 * Fetch a single case by case_slug
 */
export async function fetchCaseBySlug(slug) {
  try {
    const data = await fetchCollection('cases', { case_slug: slug, limit: 1 });
    return data.items && data.items.length > 0 ? data.items[0] : null;
  } catch (err) {
    console.error(`Error fetching case ${slug}:`, err);
    return null;
  }
}

/**
 * Fetch a gallery by gallery_slug
 */
export async function fetchGalleryBySlug(slug) {
  try {
    const data = await fetchCollection('galleries', { gallery_slug: slug, limit: 1 });
    return data.items && data.items.length > 0 ? data.items[0] : null;
  } catch (err) {
    console.error(`Error fetching gallery ${slug}:`, err);
    return null;
  }
}

/**
 * Fetch all taxonomy terms
 */
export async function fetchTaxonomyTerms(taxonomyName) {
  try {
    const res = await fetch(`${API_BASE}/public/taxonomies/${taxonomyName}/terms`);
    if (!res.ok) return [];
    return await res.json();
  } catch (err) {
    console.error(`Error fetching taxonomy terms for ${taxonomyName}:`, err);
    return [];
  }
}
